import React, { useState, useContext, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import AttendanceCard from "../../components/Employees/AttendanceCard";
import AttendanceServices from "../../services/AttendanceServices";
import useAsync from "../../hooks/useAsync"; 
import { notifyError } from "../../utils/toast"; 
import DropDownService from "../../services/DropDownService";
import { allContext } from "../../context/AllContext";
import dayjs from "dayjs";
 
function Attendance() {  
    const {  employeeID, setemployeeID, type, setType, dataUpdate, setDataUpdate } = useContext(allContext);
    const [isModal, setIsModal] = useState(false); 
    const [startTime, setstartTime] = useState(dayjs().format("YYYY-MM-DD")); 
    const [endTime, setendTime] = useState(dayjs().format("YYYY-MM-DD")); 
    const [empId, setempId] = useState(""); 
    const [resultType, setResultType] = useState();  

    const { data: employeeData } = useAsync(() => DropDownService.employeeDropDown()); 

    const { data , tableLoading} = useAsync(() => AttendanceServices?.getAllAttendance({
        employeeID : empId, 
        fromTime: startTime, 
        toTime: endTime,   
        type: type,  
    }));   

    const handleStartDate = (e) => {  
        if (startTime && endTime < e.target.value) {
        notifyError("Start time must be less then the end time"); 
        setstartTime("");
        }   
        else { 
        setstartTime(e.target.value); 
        } 
    }
 
    const handleEndDate = (e) => { 
        if(startTime && startTime >  e.target.value){
            notifyError("End time must be greater then the start time");
            setendTime("");
        }
        else{ 
            setendTime(e.target.value);
        } 
    }

    const handleSearch = () => { 
        setstartTime(startTime);  
        setendTime(endTime);
        setemployeeID(empId);
        setType(resultType);    
        setDataUpdate(!dataUpdate);
    } 

    useEffect(() => {
        handleResetButton();
    }, []);

    const handleResetButton = async () => {
        setstartTime(dayjs().format("YYYY-MM-DD"));  
        setendTime(dayjs().format("YYYY-MM-DD"));
        setemployeeID("");
        setempId("");
        setType("all");  
        setResultType("all"); 
        setDataUpdate(!dataUpdate);
    }
    return (
        <div className="container-xxl">  
            <PageHeader headerTitle="Attendance"/> 
            <div className="col-auto d-flex">
                <div className="me-5 p-2">
                    <label>Employee</label> 
                    <select className="form-select" name="employee_id" value={empId} onChange={(e)=>setempId(e.target.value)}>
                        <option value="" defaultValue >Select Employee</option>
                        {employeeData?.data?.map((employee, index) => (
                            <option key={index} value={employee?.value}>{employee?.label}</option>
                        ))}
                    </select> 
                </div>
                <div className="me-5 p-2">
                    <label>Start Date</label>
                    <input
                        type="date" name="startDate"
                        className="form-control" onChange={handleStartDate}
                        value={startTime} max={endTime}
                        />
                </div>
                <div className="me-5 p-2"> 
                    <label>End Date</label> 
                    <input
                        type="date" name="enddate"
                        className="form-control" onChange={handleEndDate}
                        value={endTime} min={startTime}
                        />
                </div>  
                <div className="me-5 p-2">
                    <label>Type</label> 
                    <select className="form-select" name="type" value={resultType} onChange={(e)=>setResultType(e.target.value)}>
                        <option value="all" defaultValue>All</option>  
                        <option value="monthWise" defaultValue>Month Wise</option> 
                    </select> 
                </div>
                <div className="me-2 pt-3">   
                    <button className="btn btn-dark me-2" style={{"marginTop":"15px"}} type="submit" onClick={handleSearch}><span className="text-white dark:text-gray-200">Search</span></button>
                </div>
                <div className="me-5 pt-3 ">   
                    <button className="btn btn-dark me-2" style={{"marginTop":"15px"}} type="submit" onClick={handleResetButton}><span className="text-white dark:text-gray-200">Reset</span></button>
                </div>
            </div> 
            <div className="row clearfix g-3">
                <div className="col-sm-12">
                    <AttendanceCard data={data} type={type} tableLoading={tableLoading}/>
                </div>
            </div> 
            <Modal centered show={isModal} onHide={() => { setIsModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Edit Attendance</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Select Person</label>
                        <select className="form-select">
                            <option >Joan Dyer</option>
                            <option value="1">Ryan Randall</option>
                            <option value="2">Phil Glover</option>
                            <option value="3">Victor Rampling</option>
                            <option value="4">Sally Graham</option>
                            <option value="5">Robert Anderson</option>
                            <option value="6">Ryan Stewart</option>
                        </select>
                    </div>
                    <div className="deadline-form">
                        <form>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-12">
                                    <label htmlFor="datepickerdedass" className="form-label">Select Date</label>
                                    <input type="date" className="form-control" id="datepickerdedass" />
                                </div>
                                <div className="col-sm-12">
                                    <label className="form-label">Attendance Type</label>
                                    <select className="form-select">
                                        <option >Full Day Present</option>
                                        <option value="1">Half Day Present</option>
                                        <option value="2">Full Day Absence</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleFormControlTextarea78d" className="form-label">Edit Reason</label>
                        <textarea className="form-control" id="exampleFormControlTextarea78d" rows="3"></textarea>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Done</button>
                    <button type="button" className="btn btn-primary">Save</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default Attendance;